import React, { lazy, Suspense } from 'react';

import Button from '~/components/core/Atomic/Buttons/Button';
import EmptyState from '~/components/core/EmptyState';

import TEXTS from '../texts';

const LazyEmptyConfigurationIllustration = lazy(
  () => import('~/components/illustrations/EmptyConfigurationIllustration')
);

const ClaimStageConfigurationEmptyState = ({ onCreateClick }: { onCreateClick: () => void }) => {
  return (
    <EmptyState
      className="m-40"
      title={TEXTS.emptyStateTitle}
      subtitle={TEXTS.emptyStateDescription}
      illustration={
        <Suspense fallback={<div className="h-[235px]" />}>
          <LazyEmptyConfigurationIllustration />
        </Suspense>
      }
      buttonComponent={
        <Button variant="contained" color="primary" onClick={onCreateClick}>
          {TEXTS.createStage}
        </Button>
      }
    />
  );
};

export default ClaimStageConfigurationEmptyState;
